import { Component, OnInit } from '@angular/core';
import { AddNewTopicsComponent } from '../../app/add-new-topics/add-new-topics.component';
import { MatDialog } from '@angular/material/dialog';
import { SortTopicsService } from "./sort-topics.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../services/shared.service';
export interface PeriodicElement {
	topic: string;
	subtopics: string;
	ccEmail: string;
	ccSMS: string;
}
@Component({
  selector: 'app-sort-topics',
  templateUrl: './sort-topics.component.html',
  styleUrls: ['./sort-topics.component.scss']
})
export class SortTopicsComponent implements OnInit {
	displayedColumns: string[] = ['topic', 'subtopics', 'ccEmail', 'ccSMS', 'icons'];
	dataSource = [];
  topicsList: any = [];
  topics: Boolean = true;
  topicSettings: Boolean = false;
  settingsTitle = "";
  elements: any = [];
  topicIndex;

  constructor(public dialog: MatDialog,
    private _sortTopicService: SortTopicsService,
    private _snackBar: MatSnackBar,
    private _sharedService: SharedService) {}

  ngOnInit(): void {

    this._sortTopicService.getAllTopics(localStorage.getItem('organization')).subscribe((response) => {
      if (response['success']) {
        this.dataSource = response['data'];
        this.topicsList = response['data'];
      }
    });
  }

  deleteTopic(topic) {
    this._sharedService.confirmationDialog("Are you sure you want to delete the Topic?", ()=>{ 
      this._sortTopicService.deleteTopic(topic).subscribe((response) => {
        console.log(response);
        if (response['success']) {
          this.ngOnInit();
        }
      });
    });
  }

  editTopic(topic) {
    const dialogRef = this.dialog.open(AddNewTopicsComponent, {
      data: topic
    });
    dialogRef.afterClosed().subscribe((data) => {
      document.body.classList.remove('modal-open');
      this.ngOnInit();
    })
  }

  addNewTopicDialog() {
    const dialogRef = this.dialog.open(AddNewTopicsComponent, {
      data: {}
    });
    dialogRef.afterClosed().subscribe((data) => {
      document.body.classList.remove('modal-open');
      this.ngOnInit();
    })
  }

  openSubtopicSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["sub_topics"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.topics = false;
    this.topicSettings = true;
  }

  openSmsSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["sms"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.topics = false;
    this.topicSettings = true;
  }

  openEmailSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["emails"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.topics = false;
    this.topicSettings = true;
  }

  backToShowTopicsPanel() {
    this.topicSettings = false;
    this.topics = true;
    this.ngOnInit();
  }

  openAddNewItem() {
    this.elements.push("");
  }

  updateTopic() {

		let topic = {
			_id: this.topicsList[this.topicIndex]['_id'],
			name: this.topicsList[this.topicIndex].name,
			sub_topics: this.topicsList[this.topicIndex].sub_topics.length > 0 ? this.topicsList[this.topicIndex].sub_topics.filter(function (e) { return e }) : [],
			emails: this.topicsList[this.topicIndex].emails.length > 0 ? this.topicsList[this.topicIndex].emails.filter(function (e) { return e }) : [],
			sms: this.topicsList[this.topicIndex].sms.length > 0 ? this.topicsList[this.topicIndex].sms.filter(function (e) { return e }) : []
		}
		this._sortTopicService.updateTopic(topic).subscribe((response) => {
			if (response['success']) {
        this.openSnackBar("Topic update successful");
			}
		});
	}

  fieldPropertiesInputChange(value, index) {
    if (this.settingsTitle === "Sub Topics") {
      this.topicsList[this.topicIndex]["sub_topics"][index] = value;
    } else if (this.settingsTitle === "cc-SMS") {
      this.topicsList[this.topicIndex]["sms"][index] = value;
    } else {
      this.topicsList[this.topicIndex]["emails"][index] = value;
    }
  }

  removeOption(element, index) {
    this.elements.splice(index, 1);
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

}
